// hooks/useClinicalNotes.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { API } from '../../config';

// Configure API base URL
const api = axios.create({
  baseURL: `${API}/clinical-notes`,
});

// GET one clinical note by appointmentId
export const useGetClinicalNote = (appointmentId) => {
  return useQuery({
    queryKey: ['clinical-note', appointmentId],
    queryFn: () => api.get(`/${appointmentId}`).then((res) =>{
      return res.data
    }),
    enabled: !!appointmentId,
  });
};

// CREATE a new clinical note
export const useCreateClinicalNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/', data).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinical-note'] });
    },
  });
};

// UPDATE an existing clinical note
export const useUpdateClinicalNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ appointmentId, data }) => api.put(`/${appointmentId}`, data).then((res) => res.data),
    onSuccess: (_, { appointmentId }) => {
      queryClient.invalidateQueries({ queryKey: ['clinical-note', appointmentId] });
    },
  });
};

// DELETE a clinical note
export const useDeleteClinicalNote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (appointmentId) => api.delete(`/${appointmentId}`).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clinical-note'] });
    },
  });
};
